import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setCompanyDiverseType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const CompanyDiverseTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Diverse"
      id="company_diverse_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCompanyDiverseType(option.id))
      }}
    />
  )
}
export default CompanyDiverseTypeDropdown
